import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let CreateUserDialog = class CreateUserDialog extends Vue {
    //creates a new user
    createUser() {
        this.$data.loading = true;
        this.$store
            .dispatch("createNewUser", this.$data.newUser)
            .then((result) => {
            console.log({ result });
            this.$data.loading = false;
            this.$emit("changeVisibility", false); // close modal
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The user has been created with id: " + result.data,
            });
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components -> CreateUserDialog.vue -> createUser");
            this.$data.loading = false; //end loading on errorcreateUser
        })
            .then(() => {
            if (this.$props.callback) {
                this.$props.callback();
            }
        });
    }
    //create an email based on the names
    generateEmail() {
        this.$data.newUser.email = (this.$data.newUser.firstName +
            "." +
            this.$data.newUser.lastName +
            "@geshdo.com").toLowerCase();
    }
};
CreateUserDialog = __decorate([
    Component({
        data() {
            return {
                theme: this.$store.getters.getTheme,
                newUser: { email: "", firstName: "", lastName: "" },
                loading: false,
            };
        },
        props: {
            show: Boolean,
            callback: Function || undefined,
        },
        created() { },
        computed: {
            showModal: {
                get() {
                    return this.$props.show;
                },
                set(newValue) {
                    this.$emit("changeVisibility", newValue);
                    return newValue;
                },
            },
        },
    })
], CreateUserDialog);
export default CreateUserDialog;
